import server from '../../public/server/server'

const mapAPI = {
    camera: server.requestPath + '/agg/camera',  // 摄像机
    helpEvent: server.requestPath + '/agg/neighborhood', // 求助事件
    alarm: server.requestPath + '/agg/alarmOwn', // 报警事件
    getRtsp: server.requestPath + '/camera/findLiveUrl',  // 摄像机详情
    police: server.requestPath + '/getOnlineUserSecurity',  // 摄像机详情
    userTrack: server.requestPath + '/user/track/userTrack', // 轨迹

    addClues: server.visualIntercom + '/emergencyLinkage/addClues', // 报警处置流程
    officerTaskUserList: server.visualIntercom + '/emergencyLinkage/officerTaskUserList', // 查询人员任务列表
    updateOfficerTask: server.visualIntercom + '/emergencyLinkage/updateOfficerTask', // 修改人员任务
    deleteOfficerTask: server.visualIntercom + '/emergencyLinkage/deleteOfficerTask', // 删除人员任务

    eventHistory: server.visualIntercom + '/emergencyLinkage/alarmByCaller', // 历史事件
    areaCode: server.requestPath + '/agg/gdMapView',  // 高德地图地址逆解析

    getGroupUserInfo: server.visualIntercom + '/videoIntercom/getGroupUserInfo',  // 获取群成员
    getPoliceUser: server.visualIntercom + '/emergencyLinkage/getPoliceUser',  // 获取上级
    addOrRemoveMeeting: server.visualIntercom + '/videoIntercom/addOrRemoveMeeting',  // 添加群成员
	
	
}

const listAPI = {
  list: server.visualIntercom + '/alarm/queryAlarmByPage', // 列表
  alarmList: server.visualIntercom + '/alarm/queryAlarmReportByPage', // 已上报列表
  datail: server.visualIntercom + '/alarm/queryAlarmDetail', // 事件详情
  participation: server.visualIntercom + '/alarm/getAlarmInvites', // 已参与列表
  caseRed: server.visualIntercom +  '/emergencyLinkage/caseRed',
  merce:server.visualIntercom+'/alarm/queryContract',//紧急联系人列表
  queryGraphicDetail:server.visualIntercom+'/alarm/queryGraphicDetail',//获取图文报警的详情
  alarmIntercom:server.visualIntercom+'/alarm/alarmIntercom',//获取报警可视对讲记录文件
  queryOverdue:server.visualIntercom+'/alarm/queryOverdue',//逾期-----查询当前用户逾期的待处理的事件
}

export {mapAPI, listAPI}
